import { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import {useNavigate, useSearchParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import Button from "../ButtonComponent";

import FeedbackForm from "../FeedbackForm";

import { BUTTON_VARIANTS } from "../constant";

import { useGetFeedbackQuestionTypeKeys } from "./queries";

import { useSaveInclusiveEducationFeedbackAnswers } from "./mutation";

import Shimmer from "../ShimmerComponent";

import { TYPE } from "./constant";

import styles from "./styles.module.scss";

import FeedbackRequiredModal from "../FeedbackRequiredModal";
import FeedbackComponent from "../FeedbackComponent";
import CertificateCourseCompleteModal from "../CertificateCourseComplete";
import { ASSESSMENT_ALLOWED, COURSE_MARKS, FEEDBACK_ALLOWED, IS_RETAKE_ATTEMPT, LMS_COURSE_ID, LMS_COURSE_NAME, RETAKE_VIEW } from "../../../../utils/cookiesmanager";

const FeedbackFormPage = () => {
  const [answered, setAnswered] = useState({});
  const [showMessage, setShowMessage] = useState(true);
  const [showWarning , setShowWarning] = useState(false);
  const [allowLeave, setAllowLeave] = useState(false);
  const [thanksForFeedBack , setThanksForFeedback] = useState(false);
  const [showCertificateModal , setShowCertificateModal] = useState(false);
  const timeoutRef = useRef(null);
  const course = TYPE.course;

  const languageId = localStorage.getItem("l_id") || 1;

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
     
  const courseId = searchParams.get("courseId") || localStorage.getItem(LMS_COURSE_ID);
  const courseName = searchParams.get("courseName") || localStorage.getItem(LMS_COURSE_NAME);

  const { data, isLoading } = useGetFeedbackQuestionTypeKeys({
    course,
    languageId,
    courseId
  });

  const allQuestions = data?.response || [];

  const isAllAnswered = allQuestions.every(
    (q) => answered[q.assQuestionId] !== undefined,
  );

  const { mutate } = useSaveInclusiveEducationFeedbackAnswers();

  const handleQuestionAnswer = (questionId, optionId) => {
    setAnswered((prev) => ({
      ...prev,
      [questionId]: optionId,
    }));
  };

  const handleGiveFeedBack = () => {
  setShowWarning(false);
  }

  const handleBackToCourse = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate('/user/course', {replace:true,state:{keepSidebarClosed:true}});
  }

  const handleExit = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate('/user/course', {replace:true});
  }

  useEffect(() => {
    // Add a dummy history entry
    window.history.pushState({ guard: true }, "", `${window.location.pathname}?${searchParams.toString()}`);

    const handlePopState = () => {
      if (!allowLeave) {
        setShowWarning(true);

        // Re-push state to stop navigation
        window.history.pushState(
          { guard: true },
          "",
          window.location.pathname
        );
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  },[allowLeave])

  const handleClick = () => {
    const questionArray = Object.entries(answered).map(([qId, aId]) => ({
      assQuestionID: String(qId),
      assAnswerID: String(aId),
    }));

    const payload = {
      courseId: courseId,
      // moduleId: moduleId,
      questionArray: questionArray,
    };

    mutate(payload, {
      onSuccess(data) {
        const { status, error } = data;

        if (!status) {
          throw new Error(error);
        }

        if(allowLeave){
          setAllowLeave(true);
          setShowWarning(false);
          window.history.back();
          return;
        }
        const marks =  localStorage.getItem(COURSE_MARKS);
        const retakeView =  localStorage.getItem(RETAKE_VIEW);

      if(marks >= 65 && marks < 75 && retakeView === '0'){
      console.log('inside if condition')
     localStorage.setItem(RETAKE_VIEW , 1);
      localStorage.setItem(IS_RETAKE_ATTEMPT , true);
     }

        // setShowMessage(true);
        setThanksForFeedback(true);
        // toast.success("Feedback submitted successfully");
        localStorage.setItem(FEEDBACK_ALLOWED,1);

        timeoutRef.current = setTimeout(() => {
        setThanksForFeedback(false);
        setShowCertificateModal(true);
       }, 2000);
      },
      onError(error) {
       
        setShowMessage(true);
        const serverMessage = error?.response?.data?.message;
        const finalMsg =
          serverMessage || error?.message || "Something went wrong";
          
        toast.error(finalMsg);

        setTimeout(() => {
          if(finalMsg === 'You already completed feedback'){
            navigate(`/user/course`, {replace:true});
          }
        }, 2000);
      },
    });
  };

  useEffect(() => {
  return () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
}, []);
  
  useEffect(() => {
        const allowed = sessionStorage.getItem(ASSESSMENT_ALLOWED);
      
        if (!allowed) {
          navigate(
            `/user/module-list?courseId=${courseId}&courseName=${courseName}`,
            {replace:true}
          );
        }
  }, []);
  

  return (
    <div className={styles.container}>
      <div className={styles["top-wrapper"]}>
        <p className={styles.title}>Feedback</p>
        <p className={styles.description}>{courseName || ''}</p>
      </div>

      <div className={styles["container-top"]}>
        <div className={styles["container-wrapper"]}>
          {isLoading ? (
            [...Array(3)].map((_, index) => (
              <Shimmer
                key={index}
                width="100%"
                height="190px"
                borderRadius="14px"
                style={{ marginBottom: "6px" }}
              />
            ))
          ) : (
            <FeedbackForm
              questionsList={allQuestions}
              handleQuestionAnswer={handleQuestionAnswer}
              answered={answered}
            />
          )}
        </div>
      </div>

      <div className={styles["bottom-wrapper"]}>
        <Button
          label="Finish & Share Feedback"
          buttonVariant={BUTTON_VARIANTS.PRIMARY}
          disabled={!isAllAnswered}
          className={styles["button-class"]}
          onClick={handleClick}
        />
      </div>
      {
        showWarning && <FeedbackRequiredModal handleGiveFeedBack = {handleGiveFeedBack} handleExit={handleExit} show={showWarning} />
      }
      {
        thanksForFeedBack && <FeedbackComponent show={thanksForFeedBack}/>
      }
      {showMessage && (
        <ToastContainer
          pauseOnHover={true}
          autoClose={2000}
          position="top-right"
        />
      )}
      {showCertificateModal && <CertificateCourseCompleteModal show={showCertificateModal} handleBackToCourse={handleBackToCourse} />}
    </div>
  );
};

export default FeedbackFormPage;
